import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/team.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm team create <scope:team> [--otp <otpcode>]
npm team destroy <scope:team> [--otp <otpcode>]
npm team add <scope:team> <user> [--otp <otpcode>]
npm team rm <scope:team> <user> [--otp <otpcode>]
npm team ls <scope>|<scope:team>
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/team.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <p>{`Note: This command is unaware of workspaces.`}</p>
    <h3>{`Description`}</h3>
    <p>{`Used to manage teams in organizations, and change team memberships. Does not
handle permissions for packages.`}</p>
    <p>{`Teams must always be fully qualified with the organization/scope they belong to
when operating on them, separated by a colon (`}<inlineCode parentName="p">{`:`}</inlineCode>{`). That is, if you have a
`}<inlineCode parentName="p">{`newteam`}</inlineCode>{` team in an `}<inlineCode parentName="p">{`org`}</inlineCode>{` organization, you must always refer to that team
as `}<inlineCode parentName="p">{`@org:newteam`}</inlineCode>{` in these commands.`}</p>
    <p>{`If you have two-factor authentication enabled in `}<inlineCode parentName="p">{`auth-and-writes`}</inlineCode>{` mode, then
you can provide a code from your authenticator with `}<inlineCode parentName="p">{`[--otp <otpcode>]`}</inlineCode>{`.
If you don't include this then you will be prompted.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`create / destroy:
Create a new team, or destroy an existing one. Note: You cannot remove the
`}<inlineCode parentName="p">{`developers`}</inlineCode>{` team, `}<a href="https://docs.npmjs.com/about-developers-team" target="_blank">{`learn more.`}</a></p>
        <p parentName="li">{`Here's how to create a new team `}<inlineCode parentName="p">{`newteam`}</inlineCode>{` under the `}<inlineCode parentName="p">{`org`}</inlineCode>{` org:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm team create @org:newteam
`}</code></pre>
        <p parentName="li">{`You should see a confirming message such as: `}<inlineCode parentName="p">{`+@org:newteam`}</inlineCode>{` once the new
team has been created.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`add:
Add a user to an existing team.`}</p>
        <p parentName="li">{`Adding a new user `}<inlineCode parentName="p">{`username`}</inlineCode>{` to a team named `}<inlineCode parentName="p">{`newteam`}</inlineCode>{` under the `}<inlineCode parentName="p">{`org`}</inlineCode>{` org:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm team add @org:newteam username
`}</code></pre>
        <p parentName="li">{`On success, you should see a message: `}<inlineCode parentName="p">{`username added to @org:newteam`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`rm:
Using `}<inlineCode parentName="p">{`npm team rm`}</inlineCode>{` you can also remove users from a team they belong to.`}</p>
        <p parentName="li">{`Here's an example removing user `}<inlineCode parentName="p">{`username`}</inlineCode>{` from `}<inlineCode parentName="p">{`newteam`}</inlineCode>{` team
in `}<inlineCode parentName="p">{`org`}</inlineCode>{` organization:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm team rm @org:newteam username
`}</code></pre>
        <p parentName="li">{`Once the user is removed a confirmation message is displayed:
`}<inlineCode parentName="p">{`username removed from @org:newteam`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`ls:
If performed on an organization name, will return a list of existing teams
under that organization. If performed on a team, it will instead return a list
of all users belonging to that particular team.`}</p>
        <p parentName="li">{`Here's an example of how to list all teams from an org named `}<inlineCode parentName="p">{`org`}</inlineCode>{`:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm team ls @org
`}</code></pre>
        <p parentName="li">{`Example listing all members of a team named `}<inlineCode parentName="p">{`newteam`}</inlineCode>{`:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm team ls @org:newteam
`}</code></pre>
      </li>
    </ul>
    <h3>{`Details`}</h3>
    <p><inlineCode parentName="p">{`npm team`}</inlineCode>{` always operates directly on the current registry, configurable from
the command line using `}<inlineCode parentName="p">{`--registry=<registry url>`}</inlineCode>{`.`}</p>
    <p>{`You must be a `}<em parentName="p">{`team admin`}</em>{` to create teams and manage team membership, under
the given organization. Listing teams and team memberships may be done by
any member of the organization.`}</p>
    <p>{`Organization creation and management of team admins and `}<em parentName="p">{`organization`}</em>{` members
is done through the website, not the npm CLI.`}</p>
    <p>{`To use teams to manage permissions on packages belonging to your organization,
use the `}<inlineCode parentName="p">{`npm access`}</inlineCode>{` command to grant or revoke the appropriate permissions.`}</p>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`registry`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: "`}<a parentName="li" {...{
          "href": "https://registry.npmjs.org/%22"
        }}>{`https://registry.npmjs.org/"`}</a></li>
      <li parentName="ul">{`Type: URL`}</li>
    </ul>
    <p>{`The base URL of the npm registry.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`otp`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or String`}</li>
    </ul>
    <p>{`This is a one-time password from a two-factor authenticator. It's needed
when publishing or changing package permissions with `}<inlineCode parentName="p">{`npm access`}</inlineCode>{`.`}</p>
    <p>{`If not set, and a registry response fails with a challenge for a one-time
password, npm will prompt on the command line for one.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`parseable`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Output parseable results from commands that write to standard output. For
`}<inlineCode parentName="p">{`npm search`}</inlineCode>{`, this will be tab-separated table format.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`json`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Whether or not to output JSON data, rather than the normal output.`}</p>
    <ul>
      <li parentName="ul">{`In `}<inlineCode parentName="li">{`npm pkg set`}</inlineCode>{` it enables parsing set values with JSON.parse() before
saving them to your `}<inlineCode parentName="li">{`package.json`}</inlineCode>{`.`}</li>
    </ul>
    <p>{`Not supported by all npm commands.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-access"
        }}>{`npm access`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-config"
        }}>{`npm config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/registry"
        }}>{`npm registry`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      